export default __webpack_public_path__ + "static/6788-5a536e0870ab3e22f8c4cd10943c6358.jpg";